/**
 * AIM brand mark — "Launch Ring": a target ring (AIM = aim) with a gold
 * arrow launching straight up through the bullseye. The arrow animates
 * upward once on load and again when the surrounding link is hovered
 * (see globals.css `.brand-mark-arrow`); static under prefers-reduced-motion.
 */
export default function BrandMark({ className = "h-7 w-7" }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="bm-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" style={{ stopColor: "var(--cp-accent)" }} />
          <stop offset="1" style={{ stopColor: "var(--cp-accent-2)" }} />
        </linearGradient>
        <linearGradient id="bm-gold" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#f59e0b" />
          <stop offset="1" stopColor="#fbbf24" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="url(#bm-bg)" />
      <circle cx="32" cy="36" r="15" stroke="#ffffff" strokeWidth="4.5" fill="none" opacity="0.92" />
      <circle cx="32" cy="36" r="5.5" fill="#ffffff" opacity="0.92" />
      <path
        className="brand-mark-arrow"
        d="M32 52 L32 12 M32 12 L25 20 M32 12 L39 20"
        stroke="url(#bm-gold)"
        strokeWidth="5.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
